import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsAgentDetailMessages = defineMessages(
  "settings-agent-detail",
  en,
);
